import { Link } from "react-router-dom-v5-compat";
import {
  useModuleBEM,
  useUiStyles,
  IconNameEnum,
} from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon, Logo } from "@tenant/ui";
import clsx from "clsx";
import { SessionWidget } from "../../../components/AuthModule/SessionWidget";
import defaultStyles from "./PageHeader.module.scss";
import { TripsLink } from "@/components/TripsLink";
import { getHomeUrl } from "@/utils/urls";

export interface PageHeaderComponentProps extends PlatformComponentProps {
  contentClassName?: string;
  fullWidth?: boolean;
}
export const PageHeader = ({
  children,
  className,
  contentClassName,
  fullWidth,
}: PageHeaderComponentProps) => {
  const COMPONENT_KEY = CoreUiComponents.PageHeader;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  const homeUrl = getHomeUrl();
  return (
    <div className={clsx(block, className)} id={CoreUiComponents.PageHeader}>
      <div
        className={clsx(cn("content"), contentClassName, {
          [cn("full-width")]: fullWidth,
        })}
      >
        <div className={cn("logo")}>
          <Link to="/">
            <Logo />
          </Link>
        </div>

        <div className={cn("back-to-perkspot-container")}>
          <a href={homeUrl} referrerpolicy="no-referrer-when-downgrade">
            <Icon
              className={cn("back-to-perkspot-icon")}
              iconName={IconNameEnum.backIcon}
            />
          </a>
          <div className={cn("back-to-perkspot-text-container")}>
            <div className={cn("back-to-perkspot-label")}>
              {t("header.backToPerkspotLabel")}
            </div>
            <div>
              <a
                href={homeUrl}
                className={cn("back-to-perkspot-link")}
                referrerpolicy="no-referrer-when-downgrade"
              >
                {t("header.backToPerkspot")}
              </a>
            </div>
          </div>
        </div>

        {children}

        <div className={cn("spacer")} />
        <TripsLink className={cn("trips-link")}>
          {t("headerMenu.myTrips")}
        </TripsLink>
        <div className={cn("session-widget-container")}>
          <SessionWidget />
        </div>
      </div>
    </div>
  );
};
